import { queryOptions } from "@tanstack/react-query";
import {
  getAdminSocialEmotionalOverview,
  getSchoolSocialEmotionalOverview,
} from "#/modules/sociaal-emotioneel/social-emotional.functions";
import type { TenantQueryKey } from "#/modules/util.fetch-client/tenant-query-key";
import type { AdminSocialEmotionalSearch, SocialEmotionalOverviewSearch } from "./schema.search";

/** Follows the tenant segment — invalidate `[tenant, SOCIAL_EMOTIONAL_OVERVIEW_QUERY_KEY]` to refresh every filter variant. */
export const SOCIAL_EMOTIONAL_OVERVIEW_QUERY_KEY = "social-emotional-overview";

// Same rationale as the activities overview: the route loader primes these queries via
// `ensureQueryData`, so the cache entry carries a truthful fetch time and this staleTime is honest.
const OVERVIEW_STALE_TIME = 30_000;

export function socialEmotionalOverviewQueryOptions(
  tenant: TenantQueryKey,
  filters: SocialEmotionalOverviewSearch,
) {
  return queryOptions({
    // The server fn resolves the school from the page URL, not from `filters` — the tenant
    // segment is what keeps two schools' lists from colliding under one cache key.
    queryKey: [tenant, SOCIAL_EMOTIONAL_OVERVIEW_QUERY_KEY, filters] as const,
    queryFn: () => getSchoolSocialEmotionalOverview({ data: filters }),
    staleTime: OVERVIEW_STALE_TIME,
  });
}

// Sentinel tenant segment for the admin list — keeps the `[tenant, root, filters]` key shape, so
// the tenant-less `tenantQueryFilter` predicate (root key at index 1) invalidates this entry too.
const ADMIN_TENANT_KEY = "admin";

export function adminSocialEmotionalOverviewQueryOptions(filters: AdminSocialEmotionalSearch) {
  return queryOptions({
    queryKey: [ADMIN_TENANT_KEY, SOCIAL_EMOTIONAL_OVERVIEW_QUERY_KEY, filters] as const,
    queryFn: () => getAdminSocialEmotionalOverview({ data: filters }),
    staleTime: OVERVIEW_STALE_TIME,
  });
}
